// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dqbIF {\n  padding: unset;\n  text-align: center;\n  color: var(--content-default);\n}\n\n.dqbIF svg {\n  height: var(--schoolinks-icon-xl) !important;\n  width: var(--schoolinks-icon-xl) !important;\n  color: var(--content-default);\n}\n\n.TGWXZ {\n  border-color: var(--border-color-brand-default);\n  margin: var(--space-200) 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"schooLinksLogo": "dqbIF",
	"divider": "TGWXZ"
};
export default ___CSS_LOADER_EXPORT___;
